import util from '@/libs/util'
import router from '@/router'
import store from '@/store'
import axios from 'axios'
import { Notification } from 'element-ui'

function AxiosConfig (axios, app) {
  this.$axios = axios
  this.app = app
  this.projectId = ''
  function errorLog (err) {
    store.dispatch('d2admin/log/add', {
      type: 'error',
      err,
      info: '数据请求异常'
    })
    if (process.env.NODE_ENV === 'development') {
      util.log.danger('>>>>>> Error >>>>>>')
      console.log(err)
    }
    Notification({
      title: '错误',
      position: 'bottom-right',
      message: err.message,
      type: 'error',
      duration: 5 * 1000
    })
  }
  const service = axios.create({
    baseURL: process.env.VUE_APP_API + app + '/',
    headers: {
      'content-type': 'application/json'
    },
    timeout: 60000 // 请求超时时间(5s太少了，增加到60s)
  })
  service.interceptors.request.use(
    config => {
      const token = util.cookies.get('token')
      config.headers.Authorization = token || ''
      return config
    },
    error => {
      console.log(error)
      Promise.reject(error)
    }
  )
  service.interceptors.response.use(
    response => {
      let contentType = response.headers['content-type']
      if (contentType && contentType.indexOf('json') > -1) {
        const { code, message } = response.data
        if (code === 403) {
          Notification({
            title: '错误',
            position: 'bottom-right',
            message: message || '登录已经过期,请重新登录！',
            type: 'error',
            duration: 5 * 1000
          })
          util.cookies.set('token', '')
          const open = util.cookies.get('open-client')
          if (open) {
            router.push({
              name: 'info'
            })
          } else {
            router.push({
              name: 'login'
            })
          }
        } else if (code === 506) {
          Notification({
            title: '错误',
            position: 'bottom-right',
            message: message || '请修改密码后，再继续操作！',
            type: 'error',
            duration: 5 * 1000
          })
          router.push({
            name: 'my-password'
          })
        } else if (code !== 200) {
          Notification({
            title: '错误',
            position: 'bottom-right',
            message: message || '服务异常,请与管理员联系！',
            type: 'error',
            duration: 5 * 1000
          })
        }
      }
      return response
    },
    error => {
      if (error && error.response) {
        switch (error.response.status) {
          case 400:
            error.message = '请求错误'
            break
          case 401:
            error.message = '未授权，请登录'
            break
          case 403:
            error.message = '拒绝访问'
            break
          case 404:
            error.message = `请求地址出错: ${error.response.config.url}`
            break
          case 408:
            error.message = '请求超时'
            break
          case 500:
            error.message = '服务器内部错误'
            break
          case 501:
            error.message = '服务未实现'
            break
          case 502:
            error.message = '网关错误'
            break
          case 503:
            error.message = '服务不可用'
            break
          case 504:
            error.message = '网关超时'
            break
          case 505:
            error.message = 'HTTP版本不受支持'
            break
          default:
            break
        }
      }
      errorLog(error)
      return Promise.reject(error)
    }
  )
  this.service = service

  this.initConfig = function (params, config) {
    config.params = config.params || {}
    config.params = Object.assign(config.params, params)
    config.headers = config.headers || {}
    let projectId = this.projectId
    if (!projectId) {
      try {
        projectId = store.state.system.common.route.params.projectId
      } catch (e) { }
    }
    if (!projectId) {
      projectId = util.cookies.get('_PROJ_ID')
    }
    if (projectId) {
      config.headers.project = projectId
      config.headers._PROJ_ID = projectId
    }
    return config
  }

  this.get = function (url, params = {}, config = {}) {
    config = this.initConfig(params, config)
    return new Promise((resolve, reject) => {
      service.get(`${url}`, config).then(function (response) {
        resolve(response.data)
      }).catch(function (error) {
        resolve({
          success: false,
          code: 501,
          message: '服务或网络异常！'
        })
        console.log(error)
      })
    })
  }

  this.del = function (url, params = {}, config = {}) {
    config = this.initConfig(params, config)
    return new Promise((resolve, reject) => {
      service.delete(`${url}`, config).then(function (response) {
        resolve(response.data)
      }).catch(function (error) {
        resolve({
          success: false,
          code: 501,
          message: '服务或网络异常！'
        })
        console.log(error)
      })
    })
  }

  this.post = function (url, params = {}, data = {}, config = {}) {
    config = this.initConfig(params, config)
    return new Promise((resolve, reject) => {
      service.post(`${url}`, data, config).then(function (response) {
        resolve(response.data)
      }).catch(function (error) {
        resolve({
          success: false,
          code: 501,
          message: '服务或网络异常！'
        })
        console.log(error)
      })
    })
  }

  this.put = function (url, params = {}, data = {}, config = {}) {
    config = this.initConfig(params, config)
    return new Promise((resolve, reject) => {
      service.put(`${url}`, data, config).then(function (response) {
        resolve(response.data)
      }).catch(function (error) {
        resolve({
          success: false,
          code: 501,
          message: '服务或网络异常！'
        })
        console.log(error)
      })
    })
  }

  function downloadBlob (blobUrl, fileName, revokeObjectURL) {
    let downloadElement = document.createElement('a')
    downloadElement.href = blobUrl
    downloadElement.download = fileName
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement)
    if (revokeObjectURL == null || revokeObjectURL) {
      window.URL.revokeObjectURL(blobUrl)
    }
  }

  function download (resp, options) {
    let fileName = resp.headers.fn || 'data'
    fileName = decodeURIComponent(fileName)
    let blob = new Blob([resp.data], { type: options.fileType ? options.fileType : 'application/octet-binary' })
    let href = window.URL.createObjectURL(blob)
    downloadBlob(href, options.fileName || fileName)
  }

  this.downloadFile = async function (url, formData, options) {
    await service.post(`${url}`, formData, { responseType: 'arraybuffer' }).then(resp => download(resp, options))
  }

  this.getFile = async function (url, options) {
    await service.get(`${url}`, { responseType: 'blob' }).then(resp => download(resp, options))
  }
}

let apiAxios = new AxiosConfig(axios, '/api')

export default apiAxios

export const $baseSrv = apiAxios

export const $allSrv = new AxiosConfig(axios, '')

export const $projectSrv = new AxiosConfig(axios, '/project')

export const $userSrv = new AxiosConfig(axios, '/user')

export const $openSrv = new AxiosConfig(axios, '/open')
